/** Site-wide JavaScript definitions and settings */

GOOGLE_MAPS_API_KEY = 'AIzaSyATPpLYe0uTDPZB-U1NOTo4QkxLL6Bgoss';